export const fetchExternalScript = (
  src: string,
  onLoad: () => void,
  onErr: (err: string | Event) => void
) => {
  const script = document.createElement("script");
  script.setAttribute("src", src);
  script.onload = onLoad;
  script.onerror = (err: string | Event) => {
    onErr(err);
    document.body.removeChild(script);
  };
  document.body.appendChild(script);
};
